import { FC } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import HistoryIcon from '@mui/icons-material/History';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import RowActions, {
  RowAction,
  rowActionsWidth,
} from '../../components/RowActions';
import { EntityAction, EntityRow } from './types';

// The four per-row actions of the services and functions administration,
// over the common "•••" (components/RowActions): rename,
// activate or deactivate (depending on the state), history and remove from the list.

export const ENTITY_ACTIONS_WIDTH = rowActionsWidth(4);

const actionsFor = (entity: EntityRow): RowAction<EntityAction>[] => [
  {
    key: 'rename',
    label: 'Renommer',
    icon: <EditOutlinedIcon fontSize="small" />,
  },
  entity.active
    ? {
        key: 'toggle',
        label: 'Désactiver',
        icon: <ToggleOffOutlinedIcon fontSize="small" />,
      }
    : {
        key: 'toggle',
        label: 'Activer',
        icon: <ToggleOnOutlinedIcon fontSize="small" />,
      },
  {
    key: 'history',
    label: 'Historique',
    icon: <HistoryIcon fontSize="small" />,
  },
  {
    key: 'remove',
    label: 'Retirer',
    icon: <DeleteOutlinedIcon fontSize="small" />,
  },
];

type Props = {
  entity: EntityRow;
  variant: 'table' | 'card';
  onAction: (action: EntityAction, entity: EntityRow) => void;
};

const EntityRowActions: FC<Props> = ({ entity, variant, onAction }) => (
  <RowActions
    subject={entity.name}
    actions={actionsFor(entity)}
    variant={variant}
    width={ENTITY_ACTIONS_WIDTH}
    onAction={(action) => onAction(action, entity)}
  />
);

export default EntityRowActions;
